import { render, staticRenderFns } from "./NewBoxBlock.vue.html?vue&type=template&id=7bb47a2b&scoped=true&"
import script from "./NewBoxBlock.component.js?vue&type=script&lang=vueJs&"
export * from "./NewBoxBlock.component.js?vue&type=script&lang=vueJs&"
import style0 from "./NewBoxBlock.scoped.scss?vue&type=style&index=0&id=7bb47a2b&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb47a2b",
  null
  
)

export default component.exports